export default "__VITE_ASSET__ZxgbRzjI__"